import React, { type ReactNode } from 'react';

import Image from '@atlaskit/image';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/text';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const resultStateContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	textAlign: 'center',
	marginTop: 'space.400',
	marginBottom: 'space.100',
});

const imageContainerStyles = xcss({
	marginBottom: 'space.150',
});

const primaryTextContainerStyles = xcss({
	marginBottom: 'space.150',
	font: 'font.heading.medium',
	fontWeight: 'font.weight.medium',
});

const secondaryTextContainerStyles = xcss({
	marginBottom: 'space.200',
});

type ResultStateProps = {
	callToAction?: ReactNode;
	imageHeight?: string;
	imageSrcDark: string | null;
	imageSrcLight: string | null;
	imageWidth?: string;
	primaryText: ReactNode;
	secondaryText: ReactNode;
	testId?: string;
};

export const ResultState = ({
	imageSrcLight,
	imageSrcDark,
	imageWidth,
	imageHeight,
	primaryText,
	secondaryText,
	callToAction,
	testId,
}: ResultStateProps): React.JSX.Element => {
	return (
		<Box xcss={resultStateContainerStyles} testId={testId}>
			<Box
				xcss={imageContainerStyles}
				style={{
					width: imageWidth || '124px',
					height: imageHeight || '124px',
				}}
			>
				{imageSrcLight && imageSrcDark && (
					<Image src={imageSrcLight} srcDark={imageSrcDark} alt="" />
				)}
			</Box>
			<Box xcss={primaryTextContainerStyles}>{primaryText}</Box>
			<Box xcss={secondaryTextContainerStyles}>
				<Text>{secondaryText}</Text>
			</Box>
			{callToAction && <Box>{callToAction}</Box>}
		</Box>
	);
};
